module.exports = __webpack_public_path__ + "static/media/8.0fc32d6.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/8.wav
// module id = QsxX
// module chunks = 0